import * as angular from 'angular';

import {
  OnInit,
  Component,
} from 'ng-metadata/core';

import searchVaccinationsHtml from './search-vaccinations.html';


@Component({
  selector: 'gwSearchVaccinations',
  template: searchVaccinationsHtml,
})
export class SearchVaccinationsComponent implements OnInit {
  public radius = 5;
  public selected = [];

  ngOnInit() {
  }

  check(name: string) {
    if (this.selected.includes(name)) {
      this.selected.splice(this.selected.indexOf(name), 1);
    } else {
      this.selected.push(name);
    }
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/vaccinations/search-vaccinations.component.ts